window.addEventListener('load', async function(){

  // --- Embla Loading & Helper Logic ---
  async function loadEmbla() {
      if (window.EmblaCarousel) return window.EmblaCarousel;
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/embla-carousel@8.6.0/embla-carousel.umd.js';
        script.onload = () => resolve(window.EmblaCarousel);
        script.onerror = reject;
        document.head.appendChild(script);
      });
  }

  // Global instances to manage destruction
  let emblaApiCase = null;
  let emblaApiStraps = null;
  let EmblaCarousel = await loadEmbla(); // Wait for library

  function initEmblaSlider(rootNode, apiReferenceCallback) {
      if (!rootNode) return;
      const viewport = rootNode.querySelector('.embla__viewport');
      const prevBtn = rootNode.querySelector('.embla__button--prev');
      const nextBtn = rootNode.querySelector('.embla__button--next');

      const options = {
        align: 'start',
        containScroll: 'trimSnaps',
        slidesToScroll: 1,
        dragFree: true
      };

      const emblaApi = EmblaCarousel(viewport, options);
      
      // Update Buttons
      const updateButtons = () => {
         if(!prevBtn || !nextBtn) return;
         prevBtn.disabled = !emblaApi.canScrollPrev();
         nextBtn.disabled = !emblaApi.canScrollNext();
      };

      if(prevBtn) prevBtn.onclick = () => emblaApi.scrollPrev();
      if(nextBtn) nextBtn.onclick = () => emblaApi.scrollNext();
      
      emblaApi.on('select', updateButtons);
      emblaApi.on('init', updateButtons);
      emblaApi.on('reInit', updateButtons); // If content changes

      apiReferenceCallback(emblaApi);
  }

  // Init initial sliders
  if(document.getElementById('case-slider-root')) {
      initEmblaSlider(document.getElementById('case-slider-root'), (api) => emblaApiCase = api);
  }
  if(document.getElementById('straps-slider-root')) {
      initEmblaSlider(document.getElementById('straps-slider-root'), (api) => emblaApiStraps = api);
  }
  
  // --- End Embla Logic ---

  var money_format = "€_money_",
  product_selections = ["case_product", "straps_product"],
  footer_element = document.querySelectorAll(".config-actions"),
  some_product_unavailable = false,
  buttons = document.querySelectorAll(".ProductForm__AddToCart"),
  straps_image_used = false,
  // Updated template with embla__slide class
  case_temaplte =
    '<div class="embla__slide Carousel__Cell check-radio __disable__" data-straps-slide="__id__">' +
    '<input type="radio" name="__type__" id="__id__" value="__id__" class="input-hidden" data-index="__index__" __disable__>' +
    '<label for="__id__" class="border-radius config-item">' +
    '<div class="item">' +
    '<img src="__image__" >' +
    "</div>" +
    '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="29" height="29" viewBox="0 0 29 29"><defs><style>.a1{fill:#fff;}.b1{fill:#f08584;}.c1{clip-path:url(#a);}</style><clipPath id="a1"><path class="a1" d="M0,0H14.135V-12.155H0Z"></path></clipPath></defs><g transform="translate(-131 -604)"><circle class="b1" cx="14.5" cy="14.5" r="14.5" transform="translate(131 633) rotate(-90)"></circle><g class="c1" transform="translate(139 624.31)"><g transform="translate(5.412 -0.234)"><path class="a1" d="M0,0A.687.687,0,0,1-.51.234.685.685,0,0,1-1.02,0L-5.095-4.514a1.291,1.291,0,0,1,0-1.7l.51-.565a1.01,1.01,0,0,1,1.531,0L-.51-3.956,6.364-11.57a1.01,1.01,0,0,1,1.531,0l.51.565a1.292,1.292,0,0,1,0,1.7Z"></path></g></g></g></svg>' +
    "</label></div>";

function handleButtonsText() {
  var buttons = document.querySelectorAll(
    ".ProductForm__AddToCart.btn.btn--primary.btn--addToCart"
  );
  for (var i = 0; i < buttons.length; i++) {
    if (some_product_unavailable) {
      buttons[i].querySelector("span").innerText = "Ausverkauft";
      buttons[i].setAttribute("disabled", true);
    } else {
      if (buttons[i].classList.contains("btn_atc_AB005")) {
        buttons[i].querySelector("span").innerText = "In den Warenkorb";
      } else {
        buttons[i].querySelector("span").innerText = "Zum Warenkorb hinzufügen";
      }
      buttons[i].removeAttribute("disabled");
    }
  }
}
function addClass(element, c) {
  if (!element) return;
  if (element.className.indexOf(c) == -1) {
    element.className += " " + c;
  }
}

function getUrlParameters() {
  const params = {};
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.has("case_id")) {
    params.caseId = urlParams.get("case_id");
  }

  if (urlParams.has("strap_id")) {
    params.strapId = urlParams.get("strap_id");
  }

  if (urlParams.has("color")) {
    params.color = urlParams.get("color");
  }

  return params;
}

function getSelectedProductIndex(container, variantId) {
  // Logic simplified, we rely on data attributes primarily now
  // For Embla scrolling, we usually don't need index unless we want to scrollTo
  return 0; // Placeholder
}

function preSelectProductsBasedOnVariantIds() {
  const params = getUrlParameters();
  if (params.caseId) {
    const selectedCaseIndex = mobile_bundle_products.case.findIndex(
      (product) => product.id === Number(params.caseId)
    );
    if (selectedCaseIndex !== -1) {
      callChangeHandlerForProduct("case", selectedCaseIndex, params.caseId);
      // Optional: scroll embla to index if needed
      if(emblaApiCase) emblaApiCase.scrollTo(selectedCaseIndex);
    }
  }

  if (params.strapId) {
    const selectedStrapIndex = mobile_bundle_products.straps.findIndex(
      (product) => product.id === Number(params.strapId)
    );
    if (selectedStrapIndex !== -1) {
      callChangeHandlerForProduct("straps", selectedStrapIndex, params.strapId);
      if(emblaApiStraps) emblaApiStraps.scrollTo(selectedStrapIndex);
    }
  }

  if (params.color) {
    const colorRadio = document.querySelector(
      `input[name="color-options"][value="${params.color}"]`
    );
    if (colorRadio) {
      colorRadio.checked = true;
      const mockEvent = { target: colorRadio };
      handleColorChange(mockEvent);
    }
  }
}

preSelectProductsBasedOnVariantIds();

function callChangeHandlerForProduct(productType, index, variantId) {
  const event = {
    target: {
      value: variantId,
      dataset: {
        index: index,
      },
    },
  };
  changeHandler(event, `${productType}_product`);
  const radioButton = document.getElementById(variantId.toString());
  if (radioButton) {
    radioButton.checked = true;
  }
}

function updateURLWithSelectedColor(color) {
  const currentURL = new URL(window.location.href);
  currentURL.searchParams.set("color", color);
  window.history.pushState(
    { path: currentURL.toString() },
    "",
    currentURL.toString()
  );
}

function removeClass(element, c) {
  if (!element) return;
  if (element.className.indexOf(c) > -1) {
    if (element.className.indexOf(" " + c) > -1)
      element.className = element.className.replace(" " + c, "");
    else element.className = element.className.replace(c, "");
  }
}
function fireResize() {
  var resizeEvent = window.document.createEvent("UIEvents");
  resizeEvent.initUIEvent("resize", true, false, window, 0);
  window.dispatchEvent(resizeEvent);
}
fireResize();

// --- Main Render Logic Adjusted for Embla ---

function renderBagShapes(shape) {
  var unavailable_cases = [];
  for (var i = 0; i < mobile_bundle_products.case.length; i++) {
    if (
      mobile_bundle_products.case[i].shape == shape &&
      mobile_bundle_products.case[i].available
    ) {
    } else {
      unavailable_cases.push(i);
    }
  }
  var template_html = "";
  
  // Destroy Embla if needed before DOM update
  if(emblaApiCase) emblaApiCase.destroy();

  const caseContainer = document.querySelector(".case-slider .embla__container");

  if (unavailable_cases.length == mobile_bundle_products.case.length) {
    caseContainer.innerHTML = "<p>" + window.configurator.nocase + "</p>";
    return;
  }

  if (unavailable_cases.length > 0) {
    for (var i = 0; i < mobile_bundle_products.case.length; i++) {
      if (unavailable_cases.indexOf(i) == -1) {
        var temp = case_temaplte;
        p = mobile_bundle_products.case[i];
        temp = temp.replace(/__id__/g, p.id);
        temp = temp.replace(/__index__/g, i);
        temp = temp.replace(/__type__/g, "case_product");
        temp = temp.replace(/__image__/g, p.featured_image);
        template_html += temp;
      }
    }
  } else {
    for (var i = 0; i < mobile_bundle_products.case.length; i++) {
      var temp = case_temaplte;
      p = mobile_bundle_products.case[i];
      temp = temp.replace(/__id__/g, p.id);
      temp = temp.replace(/__index__/g, i);
      temp = temp.replace(/__type__/g, "case_product");
      temp = temp.replace(/__image__/g, p.featured_image);
      template_html += temp;
    }
  }

  // Update HTML
  caseContainer.innerHTML = template_html;
  
  // Re-Init Embla
  initEmblaSlider(document.getElementById('case-slider-root'), (api) => emblaApiCase = api);

  fireResize();

  //rebind change events to new dom
  var radio_group = document.querySelectorAll('input[name="case_product"]');
  for (var j = 0; j < radio_group.length; j++) {
    radio_group[j].addEventListener("change", function (e) {
      changeHandler(e, "case_product");
    });
  }
}

function renderStrapsWidth(width) {
  var straps_width_based = [];

  for (var i = 0; i < mobile_bundle_products.straps.length; i++) {
    if (
      mobile_bundle_products.straps[i].width == width &&
      mobile_bundle_products.straps[i].available
    ) {
      straps_width_based.push(i);
    }
  }

  var template_html = "";
  // Destroy Embla
  if(emblaApiStraps) emblaApiStraps.destroy();

  const strapsContainer = document.querySelector(".straps-slider .embla__container");

  if (straps_width_based.length == 0) {
    strapsContainer.innerHTML = "<p>" + window.configurator.nostraps + "</p>";
    return;
  }
  if (straps_width_based.length > 0) {
    for (var i = 0; i < straps_width_based.length; i++) {
      var temp = case_temaplte;
      p = mobile_bundle_products.straps[straps_width_based[i]];
      let AvailableStrapsVariant = p.variants.filter(function (obj) {
        return (
          obj[mobile_bundle_products_selected.color_option.straps] ==
            mobile_bundle_products_selected.color &&
          obj[mobile_bundle_products_selected.size_option] ==
            mobile_bundle_products_selected.size
        );
      })[0];
      temp = temp.replace(/__id__/g, p.id);
      temp = temp.replace(/__type__/g, "straps_product");
      temp = temp.replace(/__index__/g, straps_width_based[i]);
      if (AvailableStrapsVariant) {
        if (AvailableStrapsVariant?.available) {
          temp = temp.replace(/__disable__/g, "");
        } else {
          continue;
        }
      } else {
        continue;
      }
      temp = temp.replace(/__image__/g, p.featured_image);
      template_html += temp;
    }
  }

  strapsContainer.innerHTML = template_html;
  
  // Re-Init Embla
  initEmblaSlider(document.getElementById('straps-slider-root'), (api) => emblaApiStraps = api);

  fireResize();

  //rebind change events to new dom
  var radio_group = document.querySelectorAll('input[name="straps_product"]');
  for (var j = 0; j < radio_group.length; j++) {
    radio_group[j].addEventListener("change", function (e) {
      changeHandler(e, "straps_product");
    });
  }
}

function checkSizeAvailable() {
  if (mobile_bundle_products_selected.straps) {
    straps_size_variants =
      mobile_bundle_products_selected.straps.variants.filter(function (obj) {
        return (
          obj[mobile_bundle_products_selected.color_option.straps] ==
            mobile_bundle_products_selected.color && obj.available
        );
      });
    document.querySelectorAll('[name="size-options"]').forEach((so) => {
      so.parentElement.style.display = "block";
    });
    for (let avl_variant of straps_size_variants) {
      document.getElementById(avl_variant.option1).parentElement.style.display =
        "block";
    }
  }
  var color_options = document.querySelectorAll(
    ".options_bundle .swatch-element"
  );
  color_options.forEach(function (swatch) {
    removeClass(swatch, "soldout");
  });

  var last_color = null,
    atleastoneout = false;
  mobile_bundle_products_selected.case?.variants.forEach(function (variant_) {
    last_color =
      variant_[mobile_bundle_products_selected.color_option.case].toLowerCase();
    color_variants = mobile_bundle_products_selected.case.variants.filter(
      function (obj) {
        return (
          obj[
            mobile_bundle_products_selected.color_option.case
          ].toLowerCase() == last_color && obj.available
        );
      }
    );
    if (color_variants.length == 0) {
      addClass(
        document.querySelector(
          '.options_bundle.case .swatch-element[data-value="' +
            last_color +
            '"]'
        ),
        "soldout"
      );
      atleastoneout = true;
    }
  });

  if (atleastoneout) {
    document
      .querySelector(".options_bundle .swatch-element:not(.soldout) label")
      .click();
  }

  if (
    mobile_bundle_products_selected.straps &&
    straps_size_variants.length == 1
  ) {
    removeClass(document.querySelector(".size-optios"), "unavailable");
    addClass(
      document.querySelector(".size-optios"),
      "partial only-" +
        straps_size_variants[0][mobile_bundle_products_selected.size_option]
    );
    document
      .querySelector(
        'label[for="' +
          straps_size_variants[0][mobile_bundle_products_selected.size_option] +
          '"]'
      )
      .click();
  } else {
    document.querySelector(".size-optios").className =
      "selector-wrapper size-optios";
  }
}

function checkAvailability(shape) {
  if (shape != "") {
    addClass(document.querySelector(".Product__Wrapper2"), "shape-selected");
  } else {
    removeClass(document.querySelector(".Product__Wrapper2"), "shape-selected");
  }

  if (document.querySelector(".ProductForm__Error") != null)
    document.querySelectorAll(".ProductForm__Error").forEach(function (e) {
      e.remove();
    });

  var case_variant = null,
    straps_variant = null;
  if (mobile_bundle_products_selected.case) {
    addClass(document.querySelector(".Product__Wrapper2"), "case-selected");
    checkSizeAvailable();
  }

  if (mobile_bundle_products_selected.straps) {
    straps_variant = mobile_bundle_products_selected.straps.variants.filter(
      function (obj) {
        return (
          obj[mobile_bundle_products_selected.color_option.straps] ==
            mobile_bundle_products_selected.color &&
          obj[mobile_bundle_products_selected.size_option] ==
            mobile_bundle_products_selected.size
        );
      }
    )[0];
    checkSizeAvailable();
    addClass(document.querySelector(".Product__Wrapper2"), "straps-selected");
  }

  if (
    (case_variant && !case_variant.available) ||
    (straps_variant && !straps_variant.available)
  ) {
    footer_element.forEach(function (e) {
      var errorMessageElement = document.createElement("span");
      errorMessageElement.className =
        "ProductForm__Error Alert Alert--error logic-alert";
      errorMessageElement.innerHTML = window.configurator.soldout;
      e.insertAdjacentElement("afterend", errorMessageElement);
    });
    return;
  }
}
function changeHandler(event, selector) {
  var product_type = selector.split("_")[0];
  var index = event.target.dataset["index"];
  var pindex = event.target.dataset["productIndex"];

  if (product_type == "case") {
    mobile_bundle_products_selected[product_type] =
      mobile_bundle_products[product_type][index];
  } else {
    mobile_bundle_products_selected[product_type] =
      mobile_bundle_products[product_type][index];
  }

  handleButtonsText();
  handleProductsChange(product_type, selector, index, pindex);
  updateURLWithSelectedProduct(product_type, event.target.value);
}

function updateURLWithSelectedProduct(productType, variantId) {
  const url = new URL(window.location.href);
  let paramName;
  switch (productType) {
    case "case":
      paramName = "case_id";
      break;
    case "straps":
      paramName = "strap_id";
      break;
    default:
      console.error("Unsupported product type:", productType);
      return;
  }

  url.searchParams.set(paramName, variantId);
  history.replaceState(null, null, url.toString());
}

function updateImage(product_type, index) {
  var img_src = "";
  if (product_type == "case") {
    img_src =
      mobile_bundle_products.case_images[
        mobile_bundle_products_selected.color.toLowerCase()
      ][index];
    if (straps_image_used) {
      straps_image_used = false;
      var straps_product_index = document.querySelector(
        'input[name="straps_product"]:checked'
      )?.dataset.index;
      document
        .querySelector(".mobile-straps")
        .setAttribute(
          "src",
          mobile_bundle_products.straps_images[
            mobile_bundle_products_selected.color.toLowerCase()
          ][straps_product_index]
        );
    }
  } else {
    if (mobile_bundle_products_selected.case == null) {
      straps_image_used = true;
      straps_variant = mobile_bundle_products_selected.straps.variants.filter(
        function (obj) {
          return (
            obj[
              mobile_bundle_products_selected.color_option.straps
            ].toLowerCase() ==
              mobile_bundle_products_selected.color.toLowerCase() &&
            obj[mobile_bundle_products_selected.size_option] ==
              mobile_bundle_products_selected.size
          );
        }
      )[0];
      if (straps_variant.featured_image)
        img_src = straps_variant.featured_image;
      else img_src = mobile_bundle_products_selected.straps.featured_image;
    } else {
      straps_image_used = false;
      img_src =
        mobile_bundle_products.straps_images[
          mobile_bundle_products_selected.color.toLowerCase()
        ][index];
    }
  }
  document
    .querySelector(".mobile-" + product_type)
    .setAttribute("src", img_src);
}

function handleProductsChange(product_type, selector, index, pindex) {
  document.dispatchEvent(new CustomEvent("configurator-image-update"));
  var selectedTitle;
  if (product_type == "case") {
    selectedTitle = mobile_bundle_products.case[index].title;
  } else {
    selectedTitle = mobile_bundle_products.straps[index].title;
  }

  updateImage(product_type, index);

  if (document.querySelector(".ProductForm__Error") != null)
    document.querySelectorAll(".ProductForm__Error").forEach(function (e) {
      e.remove();
    });

  document.querySelector('[data-selected="' + selector + '"').innerText =
    selectedTitle;
  document
    .querySelector('[data-selected="' + selector + '"')
    .classList.remove("unselect");

  checkAvailability(mobile_bundle_products_selected.shape);
  updateTotal();
}

var func_closures = [];
for (var i = 0; i < product_selections.length; i++) {
  func_closures[i] = (function (index) {
    return function () {
      var current_selector = product_selections[index];
      var radio_group = document.querySelectorAll(
        'input[name="' + current_selector + '"]'
      );
      for (var j = 0; j < radio_group.length; j++) {
        radio_group[j].addEventListener("change", function (e) {
          changeHandler(e, current_selector);
        });
      }
    };
  })(i);
}
for (var i = 0; i < product_selections.length; i++) {
  func_closures[i]();
}

function updateTotal() {
  var newTotal = 0,
    compareTotal = 0;

  if (mobile_bundle_products_selected["case"] != null) {
    newTotal += mobile_bundle_products_selected["case"].variants[0].price;
    if (mobile_bundle_products_selected["case"].variants[0].compare_at_price)
      compareTotal +=
        mobile_bundle_products_selected["case"].variants[0].compare_at_price;
    else
      compareTotal += mobile_bundle_products_selected["case"].variants[0].price;
  }
  document
    .querySelectorAll(".Product__Wrapper2 .bundle-total")
    .forEach(function (e) {
      e.innerText = money_format
        .replace("_money_", (parseFloat(newTotal) / 100).toFixed(2))
        .replace(".", ",");
    });
  document.querySelectorAll(".bundle-compareTotal").forEach(function (e) {
    e.innerText = money_format
      .replace("_money_", (parseFloat(compareTotal) / 100).toFixed(2))
      .replace(".", ",");
  });

  if (compareTotal != newTotal) {
    document.querySelectorAll(".bundle-total-wrapper").forEach(function (e) {
      addClass(e, "has-compare");
    });

    document
      .querySelectorAll(".bundle-total-wrapper .saving .price")
      .forEach(function (e) {
        e.innerText = money_format
          .replace(
            "_money_",
            (parseFloat(compareTotal - newTotal) / 100).toFixed(2)
          )
          .replace(".", ",");
      });
  } else {
    document.querySelectorAll(".bundle-total-wrapper").forEach(function (e) {
      removeClass(e, "has-compare");
    });
  }
}

function handleDeselect(selector) {
  var product_type = selector.split("_")[0];
  mobile_bundle_products_selected[product_type] = null;
  document.querySelector(
    'input[name="' + selector + '"]:checked'
  ).checked = false;
  document
    .querySelector('[data-selected="' + selector + '"')
    .classList.add("unselect");
  document.querySelector(".mobile-" + product_type).setAttribute("src", "");
  if (product_type == "case") {
    removeClass(document.querySelector(".Product__Wrapper2"), "case-selected");
    updateImage("straps");
  } else {
    removeClass(
      document.querySelector(".Product__Wrapper2"),
      "straps-selected"
    );
  }
  updateTotal();
}
var selectedTitles = document.querySelectorAll("span[data-selected]");
for (var i = 0; i < selectedTitles.length; i++) {
  selectedTitles[i].addEventListener("click", function (e) {
    e.target.classList.toggle("unselect");
    handleDeselect(e.target.getAttribute("data-selected"));
    e.stopPropagation();
  });
}

function handleColorChange(e) {
  document.querySelector(".label-color-selected").innerText = e.target.value;
  mobile_bundle_products_selected.color = e.target.value;

  if (mobile_bundle_products_selected.straps) {
    var straps_product_index = document.querySelector(
      'input[name="straps_product"]:checked'
    )?.dataset.index;
    updateImage("straps", straps_product_index);
  }

  if (mobile_bundle_products_selected.case) {
    var case_product_index = document.querySelector(
      'input[name="case_product"]:checked'
    )?.dataset.index;
    updateImage("case", case_product_index);
  }

  document.dispatchEvent(new CustomEvent("configurator-image-update"));
  checkStrapsAvailable();
  renderStrapsWidth(
    document.querySelector('input[name="width-options"]:checked').value
  );
  updateURLWithSelectedColor(e.target.value);
}

var color_radio_group = document.querySelectorAll(
  'input[name="color-options"]'
);
for (var j = 0; j < color_radio_group.length; j++) {
  color_radio_group[j].addEventListener("change", handleColorChange);
}

var width_radio_group = document.querySelectorAll(
  'input[name="width-options"]'
);
for (var j = 0; j < width_radio_group.length; j++) {
  width_radio_group[j].addEventListener("change", function (e) {
    document.querySelector(".label-width-selected").innerText =
      e.target.value.toUpperCase();
    mobile_bundle_products_selected.width = e.target.value;
    renderStrapsWidth(e.target.value);
  });
}

var color_radio_group = document.querySelectorAll('input[name="size-options"]');
for (var j = 0; j < color_radio_group.length; j++) {
  color_radio_group[j].addEventListener("change", function (e) {
    document.querySelector(".label-size-selected").innerText = e.target.value;
    mobile_bundle_products_selected.size = e.target.value;
    updateTotal();
    checkStrapsAvailable();
  });
}
var color_radio_group = document.querySelectorAll('input[name="shape_number"]');
for (var j = 0; j < color_radio_group.length; j++) {
  color_radio_group[j].addEventListener("change", function (e) {
    mobile_bundle_products_selected.shape = e.target.value;
    renderBagShapes(e.target.value);
    checkAvailability(e.target.value);
  });
}

function checkStrapsAvailable() {
  var all_straps_slides = document.querySelectorAll("div[data-straps-slide]");
  all_straps_slides.forEach((slide) => {
    slide.classList.remove("force-hide");
  });

  mobile_bundle_products.straps.forEach((strap) => {
    if (strap.available) {
      let available_variants = strap.variants.filter((obj) => {
        return (
          obj.available &&
          obj[
            mobile_bundle_products_selected.color_option.straps
          ].toLowerCase() ==
            mobile_bundle_products_selected.color.toLowerCase() &&
          obj[mobile_bundle_products_selected.size_option].toLowerCase() ==
            mobile_bundle_products_selected.size.toLowerCase()
        );
      });
      if (available_variants.length == 0) {
        document
          .querySelector('div[data-straps-slide="' + strap.id + '"]')
          ?.classList.add("force-hide");
      }
    }
  });
  
  // Refresh Embla because elements might be hidden
  if(emblaApiStraps) emblaApiStraps.reInit();
}

function bundleSubmit(event) {
  if (document.querySelector(".ProductForm__Error") != null) {
    document.querySelectorAll(".ProductForm__Error").forEach(function (e) {
      e.remove();
    });
  }

  var items = [],
    case_variant = null,
    straps_variant = null;
  if (mobile_bundle_products_selected.case) {
    case_variant = mobile_bundle_products_selected.case.variants.filter(
      function (obj) {
        return (
          obj.option1.toLowerCase() ==
          mobile_bundle_products_selected.color.toLowerCase()
        );
      }
    )[0];
    items.push({ id: case_variant.id, quantity: 1 });
  }

  if (mobile_bundle_products_selected.straps) {
    straps_variant = mobile_bundle_products_selected.straps.variants.filter(
      function (obj) {
        return (
          obj[
            mobile_bundle_products_selected.color_option.straps
          ].toLowerCase() ==
            mobile_bundle_products_selected.color.toLowerCase() &&
          obj[mobile_bundle_products_selected.size_option].toLowerCase() ==
            mobile_bundle_products_selected.size.toLowerCase()
        );
      }
    )[0];
    items.push({ id: straps_variant.id, quantity: 1 });
  }

  if (
    (case_variant && !case_variant.available) ||
    (straps_variant && !straps_variant.available)
  ) {
    return;
  }

  var addToCartButton = event.target;
  addToCartButton.setAttribute("disabled", "disabled");

  document.dispatchEvent(new CustomEvent("theme:loading:start"));

  fetch("/cart/add.js", {
    body: JSON.stringify({
      items: items,
    }),
    credentials: "same-origin",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  }).then(function (response) {
    document.dispatchEvent(new CustomEvent("theme:loading:end"));

    if (response.ok) {
      addToCartButton.removeAttribute("disabled");
      window.preCardOpenHandler && window.preCardOpenHandler();
      if ($(window).width() > 1024) {
        $("[data-cart-pc]").trigger("click");
      } else {
        $("[data-mobile-cart]").trigger("click");
      }
    } else {
      response.json().then(function (content) {
        var errorMessageElement = document.createElement("span");
        errorMessageElement.className = "ProductForm__Error Alert Alert--error";
        errorMessageElement.innerHTML = content["description"];
        addToCartButton.removeAttribute("disabled");
        addToCartButton.insertAdjacentElement("afterend", errorMessageElement);
        setTimeout(function () {
          errorMessageElement.remove();
        }, 2500);
      });
    }
  });
}

for (var i = 0; i < buttons.length; i++) {
  buttons[i].addEventListener("click", function (e) {
    bundleSubmit(e);
  });
}

// Filter out sold-out straps on initial page load
var checkedWidth = document.querySelector('input[name="width-options"]:checked');
if (checkedWidth) {
  renderStrapsWidth(checkedWidth.value);
}

});